import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var PolygonMaskInline = /*#__PURE__*/function () {
  function PolygonMaskInline() {
    _classCallCheck(this, PolygonMaskInline);
    this.arrangement = "one-per-point";
  }
  _createClass(PolygonMaskInline, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.arrangement !== undefined) {
        this.arrangement = data.arrangement;
      }
    }
  }]);
  return PolygonMaskInline;
}();